(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["siesie-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('siesie-hero-carousel')) {
    customElements.define('siesie-hero-carousel', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (this.events || !this.isConnected) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-slide-to]'));
        this.status = this.querySelector('.siesie-carousel__status');
        this.wrapper = this.closest('.siesie-carousel-section');
        this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
        this.setAttribute('data-enhanced', '');

        this.addEventListener('click', event => {
          const dot = event.target.closest('[data-slide-to]');
          if (dot && this.contains(dot)) this.show(Number(dot.dataset.slideTo));
        }, options);

        this.addEventListener('keydown', event => {
          if (event.target !== this && !event.target.closest('[data-slide-to]')) return;
          let index = this.index;
          if (event.key === 'ArrowRight') index++;
          else if (event.key === 'ArrowLeft') index--;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.slides.length - 1;
          else return;
          event.preventDefault();
          this.show(index);
          if (event.target !== this) this.dots[this.index]?.focus({ preventScroll: true });
        }, options);

        this.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.pointerType === 'mouse') return;
          if (event.target.closest('a, button')) return;
          this.gesture = { x: event.clientX, y: event.clientY, id: event.pointerId };
          this.setPointerCapture(event.pointerId);
        }, options);

        this.addEventListener('pointerup', event => {
          if (!this.gesture || event.pointerId !== this.gesture.id) return;
          const dx = event.clientX - this.gesture.x;
          const dy = event.clientY - this.gesture.y;
          this.gesture = null;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) {
            this.show(this.index + (dx < 0 ? 1 : -1));
          }
        }, options);
        this.addEventListener('pointercancel', () => { this.gesture = null; }, options);

        this.scheduleLayout = () => {
          cancelAnimationFrame(this.layoutFrame);
          this.layoutFrame = requestAnimationFrame(() => this.syncLayout());
        };
        window.addEventListener('resize', this.scheduleLayout, options);
        window.addEventListener('pageshow', this.scheduleLayout, options);
        window.visualViewport?.addEventListener('resize', this.scheduleLayout, options);
        document.addEventListener('shopify:section:reorder', this.scheduleLayout, options);
        document.addEventListener('shopify:section:load', () => {
          this.observeHeader();
          this.scheduleLayout();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;
          const selected = this.slides.findIndex(slide => slide.dataset.blockId === String(event.detail?.blockId));
          if (selected >= 0) this.show(selected, false);
        }, options);

        this.observeHeader();
        this.syncLayout();
        this.warmImage(this.index + 1);
        document.fonts?.ready.then(() => {
          if (this.isConnected && this.events) this.scheduleLayout();
        });
      }

      observeHeader() {
        this.headerObserver?.disconnect();
        const header = document.getElementById('header-group');
        if (header && 'ResizeObserver' in window) {
          this.headerObserver = new ResizeObserver(this.scheduleLayout);
          this.headerObserver.observe(header);
          /* Sticky Heritage headers can make #header-group display: contents;
             observe its actual sections and header as well as the group. */
          header.querySelectorAll(':scope > .shopify-section, #header-component').forEach(element => {
            this.headerObserver.observe(element);
          });
        }
      }

      syncLayout() {
        if (!this.wrapper || !this.isConnected) return;
        const firstSection = this.wrapper.parentElement?.querySelector(':scope > .shopify-section');
        /* Use the actual document position, including Heritage's transparent
           header overlap, instead of subtracting the header a second time. */
        const top = firstSection === this.wrapper
          ? this.wrapper.getBoundingClientRect().top + window.scrollY
          : 0;
        this.wrapper.style.setProperty('--siesie-top-offset', `${Math.floor(top * 100) / 100}px`);
      }

      warmImage(index) {
        if (!this.slides.length) return;
        const slide = this.slides[(index + this.slides.length) % this.slides.length];
        const image = slide.querySelector('img');
        if (image) image.loading = 'eager';
      }

      show(index, announce = true) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        this.dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', String(dotIndex === this.index));
        });
        if (announce && this.status) {
          this.status.textContent = this.slides[this.index].getAttribute('aria-label');
        }
        this.warmImage(this.index);
        this.warmImage(this.index + 1);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.layoutFrame);
        this.events?.abort();
        this.events = null;
        this.headerObserver?.disconnect();
        this.gesture = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
